import CheckboxSearch from '@components/CheckboxSearch';
import QuillHtmlComponent from '@components/QuillHtmlEditorComponent';
import SideNav from '@components/SideNav';
import { NotificationTypes, StringFrequencyType, WorkflowRectTypes } from '@helpers/Enums';
import NotificationComponent from '@src/helpers/_showNotifications';
import { safePropertieRetrieve } from '@src/helpers/validation/ObjectValidator';
import I18n from '@src/i18n';
import { Button, Input, Radio, Select, Checkbox } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import uuid from 'uuidv4';

import { BodyContainer } from './SideNavStyle';

type PropType ={
    sidenavVisibility: boolean;
    actualNode: any;
    groups: any;
    processes: any;
    closeSidenav: Function;
    saveSidenav: Function;
    nodeData: {
        groups: string[],
        selectedProcessId?: string,
        radioProcess?: boolean,
        notification?: {
            id: string,
            type: number,
            message: string,
            title?: string
        }
    };
    workflowData?: any;
}

type StateType = {
    radioProcess: boolean;
    shouldResetCheckboxState: boolean;
    titleSideNav: string;
    selectedGroups: string[];
    selectedProcess: string;
    notificationType?: number;
    notificationMessage: string;
    afterTime?: {
        unit?: string,
        amount?: number,
        timeInSeconds?: number
    },
    notificationId?: string;
    notificationTitle: string;
    richTextNotification: string;
    extractAnswers: boolean;
}

export default class WorkflowSidenav extends Component<PropType, StateType> {
    constructor(props: PropType){
        super(props)
        this.state = {
            titleSideNav: '',
            radioProcess: false,
            shouldResetCheckboxState: false,
            selectedGroups: [],
            selectedProcess: '',
            notificationType: 1,     
            notificationMessage: '',
            afterTime: undefined,
            notificationTitle: '',
            richTextNotification: '',
            extractAnswers: false
        }
        this.handleChangeExtractAnswers = this.handleChangeExtractAnswers.bind(this)
        this.enableExtractAnswer = this.enableExtractAnswer.bind(this)
    }
    handleRadioProcess = async () => {        
        this.setState({ radioProcess: !this.state.radioProcess})
    }

    UNSAFE_componentWillReceiveProps = async (nextProps: any) => {
        if(nextProps.nodeData){
            if(nextProps.actualNode && nextProps.actualNode.id !== nextProps.id){
                await this.clearState()
            }
            const { nodeData } = nextProps
            if(nodeData.type === WorkflowRectTypes.PROCESS){
                this.setState({
                    selectedProcess: nodeData.selectedProcessId,
                    selectedGroups: nodeData.groups.map((r: any) => Number(r)).filter((r: any) => !isNaN(r)),
                    radioProcess: nodeData.radioProcess,
                    afterTime: nodeData.afterTime
                })
            } else {
                const isRichText = this.isRichText(nodeData)
                this.setState({
                    notificationId: nodeData.notification ? nodeData.notification.id : '',
                    notificationMessage: nodeData.notification && !isRichText ? nodeData.notification.message : '',
                    richTextNotification: nodeData.notification && isRichText ? nodeData.notification.message : '',
                    notificationTitle: nodeData.notification ? nodeData.notification.title : '',
                    selectedGroups: nodeData.groups.map((r: any) => Number(r)).filter((r: any) => !isNaN(r)),
                    notificationType: nodeData.notification ? nodeData.notification.type : undefined,
                    extractAnswers: nodeData.notification && nodeData.notification.extractAnswers ? true : false
                })
            }
        }
        
    }

    isRichText = (data: any) => {
        const message = safePropertieRetrieve(data, 'notification.message');
        if(message){
            if(message.includes('<p>')) return true
        }
        return false
    }

    clearState = async () => {
        this.setState({
            radioProcess: false,
            shouldResetCheckboxState: false,
            selectedGroups: [],
            selectedProcess: '',
            notificationType: undefined,
            notificationMessage: '',
            notificationId: '',
            afterTime: undefined
        })
    }
    
    onCancelSideNav = async () => {
        this.props.closeSidenav();
        this.clearState()
    }

    resetCheckboxStateHandler = async (trueOrFalse: boolean) => {
        this.setState({ shouldResetCheckboxState: trueOrFalse })
    }
    
    
    setprocess = async (processId: string) => {
        this.setState({selectedProcess: processId})
    }
    
    componentDidMount() {
        this.props.actualNode && this.setSliderTittle(this.props.actualNode.type)
    }

    enableExtractAnswer () {
        const { workflowData, actualNode } = this.props
        const precedent = workflowData.filter((w: any) => actualNode.from ? actualNode.from.includes(w.id) : false)
        if (precedent.length === 0) return null
        if (precedent.length === 1 && precedent[0].type === 1) return precedent[0]

        const precedentIsProcess = precedent.filter((p: any) => p.type === 1)
        if (precedentIsProcess.length === 1) return precedentIsProcess[0]
        if (precedentIsProcess.length > 1) return null
        if (precedent.length > 1) return null

        const ancestral = workflowData.filter((w: any) => precedent[0].from ? precedent[0].from.includes(w.id) : false)
        if (ancestral.length === 0) return null
        if (ancestral.length === 1 && ancestral[0].type === 1) return ancestral[0]

        const ancestralIsProcess = ancestral.filter((a: any) => a.type === 1)
        if (ancestralIsProcess.length === 1) return ancestralIsProcess[0]

        return null
    }
    
    setSliderTittle = async (type: any) => {
        let title = type === WorkflowRectTypes.PROCESS ? "Processo" : "Notificação";
            this.setState({
                titleSideNav: title,
            })  
    }

    handleSelectChange = async (value: any) => {
        const selectedGroups = value
        this.setState({selectedGroups})
    }

    dictionaryGenerator = (message: string, title: string) => {
     //only works with hardcoded values;
        let editedMessage = `${message} ${title}`;
        const originalTags = []
        
        while(editedMessage.indexOf('{{') !== -1){
            let tagStart = editedMessage.indexOf('{{');
            let tagEnd = editedMessage.indexOf('}}');
            let currentTag = editedMessage.substr(tagStart, (tagEnd - tagStart) )
            while(currentTag.indexOf('<') !== -1){
                let openingTag = currentTag.indexOf('<');
                let closingTag = currentTag.indexOf('>');
                let htmlTag = currentTag.substr(openingTag, (closingTag - openingTag) + 1);
                currentTag = currentTag.replace(htmlTag, '');
            }
            currentTag = currentTag.replace('{{', '')
            currentTag = currentTag.replace('}}', '')
            originalTags.push(currentTag)
            editedMessage = editedMessage.slice(editedMessage.indexOf('}}') + 3)
        }

        const tags = {}
        for(let tag of originalTags){
            tags[tag] = this.eatonTagValues(tag)
        }
        
        return tags;
    }

    eatonTagValues = (tag: string) => {
        switch(tag){
            case 'nome_oficina':
                return {
                    sectionId: '33tshn4yp',
                    componentId:  'vx8a1z8gj'
                }
            default: 
                return {
                    sectionId: 'teste',
                    componentId: 'teste',
                }
        }
    }

    saveSideNav = async () => {
        const { actualNode } = this.props
        const { extractAnswers } = this.state

        if(actualNode.type === WorkflowRectTypes.NOTIFICATION){
            
            const passedValidation = this.sideNavValidation(actualNode.type)
            if(passedValidation){
                const { notificationType, notificationMessage, selectedGroups, notificationTitle, richTextNotification } = this.state
                
                const enableExtractAnswer =  extractAnswers ? this.enableExtractAnswer() : null

                const  savedNotificationObject = {
                    notification: {
                        id: uuid(),
                        type: notificationType,
                        message: notificationType === NotificationTypes.EMAIL ? richTextNotification : notificationMessage,
                        dictionary: notificationType === NotificationTypes.EMAIL ? this.dictionaryGenerator(richTextNotification, notificationTitle) : this.dictionaryGenerator(notificationMessage, notificationTitle),
                        title: notificationTitle,
                        extractAnswers: enableExtractAnswer ? enableExtractAnswer.id : null
                    },
                    groups: selectedGroups,
                }
                if(actualNode.broken && actualNode.broken.unfilledNodes){
                    delete actualNode.broken.unfilledNodes
                    
                    //checks for empty object
                    if(Object.keys(actualNode.broken).length === 0){
                        delete actualNode.broken
                    }
                    
                }
                this.props.saveSidenav(savedNotificationObject)
                this.clearState()
            }
        } else {
            const passedValidation = this.sideNavValidation(actualNode.type)
            
            if(passedValidation){
                const {selectedProcess, selectedGroups, radioProcess, afterTime} = this.state
                const savedProcessObject = {
                    process: selectedProcess,
                    groups: selectedGroups,
                    executedAnytime: radioProcess,
                    afterTime
                }
                this.props.saveSidenav(savedProcessObject)
                this.clearState()
            }
        }
        
    }

    sideNavValidation = (nodeType: number) => {
        const { notificationType, notificationMessage, selectedProcess, selectedGroups, afterTime, richTextNotification } = this.state
        const { actualNode } = this.props
        if(nodeType === WorkflowRectTypes.NOTIFICATION && actualNode.breadth !== 0){
            if(notificationType){
                if(notificationMessage || notificationType === NotificationTypes.EMAIL && richTextNotification){
                    if(selectedGroups && selectedGroups.length > 0){
                        return true
                    } else {
                        NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.no.groups'));
                        return false;
                    }
                } else {
                    NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.message'));
                    return false;
                }
            } else {
                NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.message.type'));
                return false;
            }
        } else if (nodeType === WorkflowRectTypes.NOTIFICATION && actualNode.breadth === 0) {
            if(notificationType){
                if(notificationMessage){
                    return true
                } else {
                    NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.message'));
                    return false;
                }
            } else {
                NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.message.type'));
                return false;
            }
        }
        
        else if(nodeType === WorkflowRectTypes.PROCESS && actualNode.breadth !== 0) {
            if(selectedProcess){
                if(selectedGroups && selectedGroups.length > 0 ){
                    if(afterTime && afterTime.amount){
                        if(afterTime.unit){
                            return true
                        } else {
                            NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.no.time.unit'));                
                            return false
                        }
                    } else {
                        NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.no.time.amount'));                
                        return false    
                    }
                } else {
                    NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.no.groups'));                    
                    return false
                }
            } else {
                NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.no.process'));
                return false
            }
        } else if(nodeType === WorkflowRectTypes.PROCESS && actualNode.breadth === 0){
            if(selectedProcess){
                return true
            } else {
                NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.validation.error.no.process'));
                return false
            }
        } 
        
    }
    
    handleNotificationTypeSelection = async (e:any) => {
        this.setState({notificationType: e.target.value})

    }
    
    handleNotificationText = async (e: any) => {
        this.setState({ notificationMessage: e.target.value})
    }

    handleRichTextSave = async (value: any) => {
        this.setState({ richTextNotification: value })
    }

    handleTitle = async (e: any) => {
        this.setState({notificationTitle: e.target.value})
    }

    handleChangeExtractAnswers (e: any) {
        this.setState({ extractAnswers: e.target.checked })
    }

    getTimeInSeconds = (afterTime: {amount: number, unit: string}) => {
        let timeInSeconds;
        let futureTime;
        let actualDate;
        switch (afterTime.unit){
            case StringFrequencyType.HOUR:
                timeInSeconds = afterTime.amount * (60 * 60)
                break;
            case StringFrequencyType.DAYS:
                timeInSeconds = afterTime.amount * 86400
                break;
            case StringFrequencyType.MONTHS:
                futureTime = moment().add(afterTime.amount, 'month')._d.getTime()
                actualDate = new Date().getTime()
                timeInSeconds = (futureTime - actualDate) / 1000
                timeInSeconds = Math.round(timeInSeconds)
                break;
            case StringFrequencyType.YEARS:
                futureTime = moment().add(afterTime.amount, 'year')._d.getTime()
                actualDate = new Date().getTime()
                timeInSeconds = (futureTime - actualDate) / 1000
                timeInSeconds = Math.round(timeInSeconds)
                break;
        }

        return timeInSeconds;
    }
        

    setTimeValue = (e: any) => {
        let regExp = new RegExp(/^\d*\.?\d*$/)

        if(regExp.test(e.target.value)){
            const { afterTime } = this.state; 
            const value = e.target.value;
            let newAfterTime;
            
            if(afterTime && afterTime.unit){
                const timeInSeconds = this.getTimeInSeconds({amount: value, unit: afterTime.unit})
                newAfterTime = Object.assign({}, afterTime, {amount: value, timeInSeconds})
            } else {
                newAfterTime = Object.assign({}, afterTime, {amount: value})
            }

            this.setState({afterTime: newAfterTime})
        }
        
        
    }

    setTimeUnit = (value: any) => {
      const { afterTime } = this.state;
      let newAfterTime;
      
      if(afterTime && afterTime.amount){
        const timeInSeconds = this.getTimeInSeconds({amount: afterTime.amount, unit: value})
        newAfterTime = Object.assign({}, afterTime, {unit: value, timeInSeconds})
      } else {
        newAfterTime = Object.assign({}, afterTime, {unit: value})
      }
      
      this.setState({afterTime: newAfterTime})
    }

    sidenavContent = (type: number) => {
        const { groups, processes, actualNode } = this.props;
        const { selectedGroups, afterTime, notificationType, extractAnswers } = this.state;
        const { Option } = Select;
        const enableExtractAnswer = this.enableExtractAnswer()
        let groupsList: any = [];
        if(groups){
            groups.map((e: any) => (
                groupsList.push(<Option key={e.id} id={e.id} value={e.id} label={e.name}>{e.name}</Option>)
        ))}
        
        switch (type) {
            case WorkflowRectTypes.PROCESS:
                return (<BodyContainer>
                            <div className='headerBody jusitify'>
                                <h3>{I18n.l('workflow.choose.process')}</h3>
                                {<CheckboxSearch 
                                    renderedData={processes}
                                    reset={this.state.shouldResetCheckboxState} 
                                    resetFunction={this.resetCheckboxStateHandler} 
                                    radio={true} 
                                    setProcess={this.setprocess}
                                    value={this.state.selectedProcess} />}
                            </div>
                        {actualNode.from != "start" && 
                        <>
                        <div className="item jusitify">
                            <h3>{I18n.l('workflow.process.executors')}</h3>
                            <Select filterOption={(input: any, option: any) => option.props.label.toLowerCase().includes(input.toLowerCase())} id="sidenav-group-select" mode="multiple" style={{ width: '83%' }} key={WorkflowRectTypes.PROCESS} placeholder={I18n.l('workflow.grupo.select')} value={selectedGroups} onChange={this.handleSelectChange}>
                                {groupsList}
                            </Select>
                        </div>
                        <div className="item jusitify">
                            <h3>{I18n.l('workflow.process.perfomed')}</h3>
                            {/* <label className='switchClass'>
                                <Switch color="primary" checked={this.state.radioProcess} onChange={this.handleRadioProcess} />
                                {I18n.l('workflow.process.moment')}
                            </label> */}
                            <div className='SelectDate jusitify'>
                                <span className="process-date-label"> {I18n.l('common.until')} </span>
                                <input pattern={"[0-9]"} id="sidenav-time-value-select" value={afterTime ? afterTime.amount : ''} onChange={this.setTimeValue} placeholder='nº' className='input-number ant-pattern'></input>
                                <Select id="sidenav-time-unit-select" value={afterTime ? afterTime.unit : ''} onChange={this.setTimeUnit} style={{width: '44%', padding: '5px', marginLeft: '4%'}}>
                                        <Select.Option value={StringFrequencyType.DAYS}>{I18n.l('frequency.days')}</Select.Option>
                                        <Select.Option value={StringFrequencyType.HOUR}>{I18n.l('frequency.hours')}</Select.Option>
                                        <Select.Option value={StringFrequencyType.MONTHS}>{I18n.l('frequency.months')}</Select.Option>
                                        <Select.Option value={StringFrequencyType.YEARS}>{I18n.l('frequency.years')}</Select.Option>
                                </Select>
                            </div>
                            <span style={{display: 'block', marginLeft: '2%'}}>{I18n.l('workflow.sidenav.date.limit')}</span>
                        </div>
                        </>
                        }
                        <div className='footer'>
                                <Button id='cancel-sidenav' className='ant-btn-background-ghost' onClick={this.onCancelSideNav}>{I18n.l('common.cancel')}</Button>
                                <Button id='save-sidenav' className='ant-btn-primary' onClick={this.saveSideNav}>{I18n.l('common.save')}</Button>
                        </div>
                    </BodyContainer>)
            case WorkflowRectTypes.NOTIFICATION: 
                const { TextArea } = Input
                const { notificationTitle } = this.state
            return (
                    <BodyContainer>
                        <div className="jusitify">
                            <h3>{I18n.l('workflow.type.notification')}</h3>
                            <Radio.Group value={notificationType}onChange={this.handleNotificationTypeSelection}>
                                 <Radio.Button checked={notificationType === NotificationTypes.EMAIL} className={notificationType === NotificationTypes.EMAIL ? 'radioSelected' : ''} value={NotificationTypes.EMAIL}>{"E-mail".toUpperCase()}</Radio.Button>
                                 <Radio.Button checked={notificationType === NotificationTypes.SMS}  className={notificationType === NotificationTypes.SMS ? 'radioSelected' : ''} value={NotificationTypes.SMS} disabled>{"SMS".toUpperCase()}</Radio.Button>
                                 <Radio.Button checked={notificationType === NotificationTypes.APP} className={notificationType === NotificationTypes.APP ? 'radioSelected' : ''} value={NotificationTypes.APP} disabled>{I18n.l("workflow.app.notification").toUpperCase()}</Radio.Button>
                             </Radio.Group>
                        </div>
                        {actualNode.breadth > 0 &&
                        <div className="item jusitify">
                            <h3>{I18n.l('workflow.recipient.notification')}</h3>                  
                            <Select filterOption={(input: any, option: any) => option.props.label.toLowerCase().includes(input.toLowerCase())} id="sidenav-group-select" mode="multiple" value={selectedGroups} key={WorkflowRectTypes.NOTIFICATION} style={{ width: '83%' }} placeholder={I18n.l('workflow.grupo.select')} onChange={this.handleSelectChange}>
                                {groupsList}
                            </Select>
                        </div>
                    }
                        <div className="item jusitify" >
                            {notificationType === NotificationTypes.EMAIL ? <h3>{I18n.l('table.notifications.subject')}</h3> : <h3>{I18n.l('widget.title')}</h3>}
                            <input 
                            value={notificationTitle}
                            className="ant-styled" 
                            style={{width: '83%'}}
                            onChange={this.handleTitle}
                            />
                        </div>
                        <div  className="item jusitify" style={{width: '83%'}}>
                            <h3>{I18n.l('workflow.write.select').toUpperCase()}</h3>
                            {notificationType === NotificationTypes.EMAIL && 
                            <>
                            <QuillHtmlComponent
                            defaultValue={this.state.richTextNotification}
                            placeholder={I18n.l("form.placeholders.textComponentMulti")}
                            onTextChange={this.handleRichTextSave} />
                            <Checkbox 
                                className="extract-answers"
                                disabled={enableExtractAnswer ? false : true}
                                checked={extractAnswers}
                                onChange={this.handleChangeExtractAnswers}
                            >
                                Extrair as respostas {enableExtractAnswer && enableExtractAnswer.name}
                            </Checkbox>
                            {!enableExtractAnswer && <div className="extract-answers-alert alert">A extração de respostas funciona somente quando não há dois ou mais processos em paralelo anterior a mensagem.</div>}
                            </>
                            }
                            {notificationType !== NotificationTypes.EMAIL &&
                            <TextArea 
                                id="sidenav-text-area"
                                placeholder={I18n.l('workflow.text.notification')} 
                                onChange={this.handleNotificationText}
                                value={this.state.notificationMessage}
                            />}
                        </div>
                        <div className='footer'>
                            <Button id="cancel-sidenav" className='ant-btn-background-ghost' onClick={this.onCancelSideNav}>{I18n.l('common.cancel')}</Button>
                            <Button id="save-sidenav" className='ant-btn-primary' onClick={this.saveSideNav}>{I18n.l('common.save')}</Button>
                        </div>
                    </BodyContainer>
                )
        }     
    }

    render() {
        const { sidenavVisibility, actualNode } = this.props;
        return (
            <div>
                <SideNav
                    visible={sidenavVisibility}
                    title={this.state.titleSideNav}
                >
                    {actualNode && this.sidenavContent(actualNode.type)}
                </SideNav>
            </div>
        )
    }
}
